
export function isNonEmptyString(input: unknown): input is string {
	return (typeof input === 'string') && (input.length > 0);
}

type PluralizeOptions = {
	/** Specify the plural string. If omitted, singular + 's' will be used. */
	plural?: string;
	/** If true, prefix with the quantity. e.g. '5 bananas'. Default false. */
	quantityPrefix?: boolean;
};
export function pluralize(count: number, singular: string, options?: PluralizeOptions): string {
	const prefix = options?.quantityPrefix ? `${count} ` : '';
	const suffix = (count === 1)
		? singular
		: options?.plural ?? (singular + 's');
	return prefix + suffix;
}

export function quote(input: string): string {
	return `"${input}"`;
}

/** @returns The original string if no longer than maxLength, otherwise a string truncated with an ellipsis. */
export function truncate(input: string, maxLength: number): string {
	if (input.length <= maxLength) {
		return input;
	} else {
		return input.trim()
			.slice(0, maxLength - 1)
			+ '…';
	}
}

export function normalizedString(input: unknown): string | undefined {
	let result: string | undefined;
	if (typeof input === 'string') {
		const trimmed = input.trim();
		result = (trimmed.length > 0) ? trimmed : undefined;
	}
	return result;
}

export function compareCaseInsensitive(a: string, b: string): boolean {
	return a.toUpperCase() === b.toUpperCase();
}

export const LOREM_IPSUM = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat';
